const ArrowUpIcon = () => {
    return <svg width="19" height="9" viewBox="0 0 19 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.2751 8.98868C18.1301 8.98868 17.985 8.94288 17.8593 8.82838L9.49546 1.91235L1.14126 8.83983C0.812504 9.11464 0.358051 9.02304 0.13566 8.63372C-0.0964015 8.24441 -0.0190478 7.70624 0.309705 7.44288L9.07968 0.16044C9.33108 -0.0456673 9.65983 -0.0456673 9.91123 0.16044L18.6812 7.43143C19.01 7.70624 19.0873 8.24441 18.8553 8.62227C18.7102 8.86273 18.4878 8.98868 18.2558 8.98868H18.2751Z" fill="var(--color-text-blue)"/>
    </svg>    
}

export default ArrowUpIcon